import * as geometryEngine from 'esri/geometry/geometryEngine'
import Polyline = require("esri/geometry/Polyline");
import Graphic = require("esri/Graphic");
import GraphicsLayer = require("esri/layers/GraphicsLayer");
import Draw = require("esri/views/draw/Draw");
import DrawAction = require("esri/views/draw/DrawAction");
import MapView = require("esri/views/MapView");
import ToolBar from "./../Toolbar";
import ToolButton from "./toolButton";
import { finalPolygon } from "./SelectionResultTable";

export default class MeasureDistanceTool extends ToolButton {
  private draw: Draw;

  // create a new graphic representing the polyline, add it to the view
  private distanceGraphic: Graphic;
  private action: DrawAction;

  constructor(viewIn: MapView, toolbarIn: ToolBar) {
    super(viewIn, toolbarIn);
    this.draw = new Draw({ view: viewIn });
  }

  deactivateTool() {
    // console.log("measureDistanceTool deactivateTool")
    document.body.style.cursor = "default";
    if (this.view.popup.content.toString().indexOf("length") === -1) { // if no results, hide popup
      this.view.popup.visible = false;
    }
    if (this.draw && this.draw.view && this.draw.activeAction) {
      this.draw.reset();
    }
  }

  createAction() {
    this.action = this.draw.create("polyline");
    this.action.on("vertex-add", ({ vertices }) => this.drawpolyline(vertices));
    this.action.on("cursor-update", ({ vertices }) => this.drawpolyline(vertices));
    this.action.on("vertex-remove", ({ vertices }) => this.drawpolyline(vertices));
    this.action.on("redo", ({ vertices }) => this.drawpolyline(vertices));
    this.action.on("undo", ({ vertices }) => this.drawpolyline(vertices));
    this.action.on("draw-complete", ({ vertices }) => {
      // console.log("measureDistanceTool draw-complete");
      this.drawpolyline(vertices);
      this.toolbar.setPanAsActiveTool();
      // this.createAction();
    });
  }

  activateTool(event: any) {
    // console.log("measureDistanceTool start")
    this.iconDiv = event.currentTarget;

    if (this.toolbar) {
      this.toolbar.setActiveTool(this as ToolButton);
    }
    try {
      if (this.view) {
        this.view.focus();
        document.body.style.cursor = "crosshair";
        this.createAction();

        this.view.popup.open({
          title: "Measure Results",
          content: "Click on map to start drawing line to measure"
        });
      }
    } catch (error) {
      console.error("Error: in measureDistanceTool " + +error.message);
    }
  }

  private drawpolyline(vertices: any) {
    // console.log("drawPolyline ", vertices);

    // remove existing graphic
    if (vertices && vertices.length > 1) {
      const drawLayer: GraphicsLayer = this.view.map.findLayerById("drawLayer") as GraphicsLayer;
      if (this.distanceGraphic) {
        drawLayer.remove(this.distanceGraphic);
      }

      // create a new polyline
      const polyline = new Polyline({
        paths: vertices,
        spatialReference: this.view.spatialReference
      });

      // this.distanceGraphic.geometry = polyline;
      this.distanceGraphic = new Graphic({
        attributes: { type: "measureDistance" },
        symbol: finalPolygon,
        geometry: polyline,
        popupTemplate: {
          title: "Measure Results",
          content: ""
        }
      });

      drawLayer.add(this.distanceGraphic);
      // calculate the area of the polyline
      let length = geometryEngine.geodesicLength(polyline, "miles");
      if (length < 0) {
        // simplify the polyline if needed and calculate the area again
        const simplifiedPolyline: Polyline = new Polyline(geometryEngine.simplify(polyline));
        if (simplifiedPolyline) {
          length = geometryEngine.geodesicLength(simplifiedPolyline, "miles");
        }
      }
      // start displaying the area of the polyline
      const feet = length * 5280;

      const content =
        "<p style='font-size:20px'>" +
        "Polyline length: " +
        length.toFixed(3) +
        " miles<br>" +
        "Polyline length: " +
        feet.toFixed(0) +
        " feet" +
        "</p>";
      this.view.popup.set("content", content);
      this.view.popup.visible = true;
      this.distanceGraphic.popupTemplate.content = content;
    }
  }
}
